import { createAction, props } from '@ngrx/store';
import { ApiRootResource } from './api-root.model';

const PREFIX = '[Api Root] ';

export const loadApiRootAction = createAction(PREFIX + 'Load Api Root');

export const loadApiRootSuccessAction = createAction(
	PREFIX + 'Load Api Root Success',
	props<{
		apiRoot: ApiRootResource;
	}>()
);
